import 'twin.macro'

import FFLogo from 'assets/icons/ff-logo.svg?component'
import ThemeToggle from 'components/UI/ThemeToggle'
import ToggleButtonGroup from 'components/UI/ToggleButtonGroup'
import Typography from 'components/UI/Typography'
import { useLanguageChange } from 'hooks/useLanguageChange'
import { Fragment } from 'react'
import tw from 'twin.macro'

import BVIButton from '../bvi'

const DesktopHeader = () => {
  const { language, onLangChange } = useLanguageChange()

  return (
    <Fragment>
      <div tw='flex-1'>
        <FFLogo width={126} height={32} tw='text-logo flex-shrink-0' />
      </div>
      <ThemeToggle twStyle={tw`mr-6`} />
      <BVIButton />
      <ToggleButtonGroup
        value={language}
        btnStyle={tw`py-2 px-3 rounded-lg`}
        options={[
          {
            value: 'ru',
            content: (
              <Fragment>
                <Typography variant='subbody' weight='bold'>
                  Рус
                </Typography>
              </Fragment>
            )
          },
          {
            value: 'kk',
            content: (
              <Fragment>
                <Typography variant='subbody' weight='bold'>
                  Каз
                </Typography>
              </Fragment>
            )
          }
        ]}
        onChange={onLangChange}
      />
    </Fragment>
  )
}
export default DesktopHeader
